import { hasRiskReviewValue } from "./riskReviewValueNormalizer";

const compare = (actual, operator, expected) => {
  switch (operator) {
    case "EQ":
    case "EQUALS":
      return actual === expected;
    case "NE":
    case "NOT_EQUALS":
      return actual !== expected;
    case "IN":
      return Array.isArray(expected) && expected.includes(actual);
    case "NOT_IN":
      return Array.isArray(expected) && !expected.includes(actual);
    case "GT":
      return Number(actual) > Number(expected);
    case "GTE":
      return Number(actual) >= Number(expected);
    case "LT":
      return Number(actual) < Number(expected);
    case "LTE":
      return Number(actual) <= Number(expected);
    case "EXISTS":
      return hasRiskReviewValue(actual);
    case "NOT_EXISTS":
      return !hasRiskReviewValue(actual);
    default:
      return true;
  }
};

export const evaluateRiskReviewCondition = (condition, values = {}) => {
  if (!condition) return true;
  if (Array.isArray(condition.conditions) && condition.conditions.length) {
    const results = condition.conditions.map((child) =>
      evaluateRiskReviewCondition(child, values),
    );
    return condition.logicalOperator === "OR"
      ? results.some(Boolean)
      : results.every(Boolean);
  }

  return compare(values[condition.fieldCode], condition.operator, condition.value);
};

export const evaluateRiskReviewRules = ({ template, values = {} }) => {
  const result = {
    visibility: {},
    required: {},
    disabled: {},
    calculated: {},
  };

  (template?.sections || []).forEach((section) => {
    (section.fields || []).forEach((field) => {
      result.visibility[field.code] =
        field.hidden !== true && evaluateRiskReviewCondition(field.visibilityRule, values);
      result.required[field.code] = Boolean(field.required);
      result.disabled[field.code] = Boolean(field.readOnly);

      (field.rules || [])
        .filter((rule) => rule.active !== false)
        .forEach((rule) => {
          const matched = evaluateRiskReviewCondition(rule.condition, values);
          if (!matched) return;

          if (rule.type === "VISIBILITY") {
            result.visibility[field.code] = rule.action?.visible !== false;
          }
          if (rule.type === "REQUIRED") {
            result.required[field.code] = rule.action?.required !== false;
          }
          if (rule.type === "DISABLE" || rule.type === "ENABLE_DISABLE") {
            result.disabled[field.code] = rule.action?.disabled !== false;
          }
        });
    });
  });

  return result;
};
